import { SUMMARY_DRAWER_OPEN } from './actionCreators';

export const summaryDrawerOpen = (open) => (dispatch) => {
  dispatch({
    type: SUMMARY_DRAWER_OPEN,
    payload: open,
  });
};
